export const locale = {
  'NO_PROCURATORY' : {
    'TITLE' : 'Нет доверенности',
    'MESSAGE' : 'У этого водителя нет доверенности. Все равно передать заказ?',
    'CONFIRM' : 'Передать',
    'DECLINE' : 'Отмена',
  },
};
